<template>
  <div :class="['kws-int-container', working ? 'disabled' : '']">
    <introduction
      v-if="!submitted && step === 0"
      :fsCcAttrs="introduction.fsCcAttrs"
      :headline="introduction.headline"
      :text="introduction.text"
      :img="introduction.img"
      @start="goOn"
    ></introduction>
    <question
      v-if="!submitted && step > 0 && questions && step <= questions.length"
      :step="step"
      :id="questions[step - 1].id"
      :key="questions[step - 1].fsCcAttrs"
      :fsCcAttrs="questions[step - 1].fsCcAttrs"
      :total="questions.length + 1"
      :text="questions[step - 1].text"
      :img="questions[step - 1].img"
      :answers="questions[step - 1].answers"
      :first="!introduction"
      :last="false"
      @go-back="goBack"
      @go-on="goOn"
    ></question>
    <!-- eslint-disable -->
    <registration
      v-if="!submitted && !error && step > questions.length && result.registration"
      :fsCcAttrs="result.registration.fsCcAttrs"
      :step="step"
      :text="result.registration.text"
      :img="result.registration.img"
      v-model="result.registration.form"
      @go-back="goBack"
      @submit="handIn"
    ></registration>
    <!-- eslint-enable -->
    <outro
      v-if="submitted"
      :fsCcAttrs="outro.fsCcAttrs"
      :headline="outro.headline"
      :text="outro.text"
      :img="outro.img"
      :link="outro.link"
    ></outro>
    <outro
      v-if="error"
      :headline="translate('errorHeadline')"
      :text="translate('errorText')"
      :img="outro.img"
    ></outro>
  </div>
</template>

<script>
import Introduction from './introduction.vue';
import Question from './question.vue';
import Registration from './registration-form.vue';
import Outro from './outro.vue';

export default {
  components: {
    Introduction,
    Question,
    Registration,
    Outro,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    introduction: Object,
    questions: Array,
    result: Object,
    outro: Object,
  },
  data: () => ({
    submitted: false,
    error: false,
    working: false,
    step: 0,
  }),
  methods: {
    goBack() {
      this.step -= 1;
    },
    goOn() {
      this.step += 1;
    },
    async handIn() {
      this.working = true;

      const apiData = {
        formName: `quiz-raffle-${this.id}`,
        data: {},
      };
      this.questions.forEach((q) => {
        apiData.data[q.id] = {
          value: q.answers.options
            .filter((o) => o.selected)
            .reduce(
              (previousAnswer, answer) => `${previousAnswer}${answer.value},`,
              '',
            )
            .replace(/,+$/g, ''),
        };
      });
      Object.keys(this.result.registration.form)
        .forEach((key) => {
          let { value } = this.result.registration.form[key];
          if (value === undefined) value = '';
          apiData.data[key] = { value };
        });

      try {
        await this.$http.post(
          `${this.result.registration.apiUrl}raffle/quiz-raffle-${this.id}`,
          apiData,
        );
        this.setCookie();
      } catch (error) {
        this.error = true;
      }

      this.working = false;
    },
    setCookie() {
      const cookieDate = new Date();
      cookieDate.setFullYear(cookieDate.getFullYear() + 10);
      document.cookie = `kws.quiz.${this.id}.submitted=true; expires=${cookieDate.toUTCString()};`;
      this.submitted = true;
    },
    readUserData() {
      if (window.currentUser) {
        // eslint-disable-next-line no-restricted-syntax
        for (const field in this.result.registration.form) {
          if (Object.prototype.hasOwnProperty.call(this.result.registration.form, field)
            && Object.prototype.hasOwnProperty.call(window.currentUser, field)
          ) {
            // eslint-disable-next-line
            this.result.registration.form[field].value = window.currentUser[field];
          }
        }
      }
    },
  },
  created() {
    if (!this.introduction) {
      this.step = 1;
    }
    this.submitted = !!document.cookie.split('; ')
      .find((row) => row.startsWith(`kws.quiz.${this.id}.submitted`));

    if (!this.submitted) {
      this.readUserData();
    }
  },
};
</script>
